import { getIn } from 'formik'
import { DashboardDropdown, DashboardInput } from 'bd-web-components'

type FormikFieldProps = {
  formikFieldType: string
  name: string
  title: string
  useFormik: any
  disabled?: boolean
  inputType?: string
  inputPlaceholder?: string
  dropdownOptions?: any
  maxLength?: number
  defaultValue?: any
}
function FormikField({
  useFormik,
  title,
  inputType,
  name,
  disabled,
  formikFieldType,
  inputPlaceholder,
  dropdownOptions,
  maxLength = 50,
  defaultValue,
}: FormikFieldProps) {
  return (
    <>
      {formikFieldType === 'input' && (
        <DashboardInput
          title={title}
          type={inputType}
          name={name}
          disabled={disabled}
          placeholder={inputPlaceholder}
          error={
            getIn(useFormik.errors, name) !== undefined &&
            getIn(useFormik.touched, name)
          }
          success={
            getIn(useFormik.errors, name) === undefined &&
            getIn(useFormik.values, name) !== ''
          }
          errorMsg={getIn(useFormik.errors, name)}
          value={getIn(useFormik.values, name) ?? ''}
          onChange={(e: any) => {
            if (e.target.value.length <= maxLength) useFormik.handleChange(e)
          }}
          onBlur={useFormik.handleBlur}
        />
      )}
      {formikFieldType === 'dropdown' && (
        <DashboardDropdown
          optionsData={dropdownOptions}
          error={
            getIn(useFormik.errors, name) !== undefined &&
            getIn(useFormik.touched, name)
          }
          defaultValue={defaultValue}
          name={name}
          title={title}
          value={
            dropdownOptions
              ? dropdownOptions.find(
                  (option: any) =>
                    option.value === getIn(useFormik.values, name)
                )
              : ''
          }
          onSelect={(option: any) =>
            useFormik.setFieldValue(name, option.value)
          }
        />
      )}
    </>
  )
}

export default FormikField
